import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "mra_jwt";

const client = axios.create({ baseURL: API, withCredentials: true });
client.interceptors.request.use((cfg) => {
  const t = typeof window !== "undefined" ? localStorage.getItem(TOKEN_KEY) : null;
  if (t) {
    cfg.headers = cfg.headers || {};
    cfg.headers.Authorization = `Bearer ${t}`;
  }
  return cfg;
});

export const fetchSurvey = async (audience) => (await client.get(`/surveys/${audience}`)).data;
export const submitSurvey = async (audience, body) => (await client.post(`/surveys/${audience}/responses`, body)).data;
export const fetchStudentSurveyStatus = async () => (await client.get("/surveys/student/status")).data;
export const dismissStudentSurvey = async () => (await client.post("/surveys/student/dismiss")).data;
export const skipSubmitSurvey = async () => (await client.post("/surveys/student/skip-submit")).data;

export const DONOR_DISMISS_KEY = "mra.donorSurveyDismissed.v1";

export const SURVEY_AUDIENCES = ["donor", "student_submit", "student_grant"];
export const SURVEY_LABELS = { donor: "Donors", student_submit: "Students, after submitting", student_grant: "Students, after the first grant" };
export const SURVEY_SHORT = { donor: "Donor survey", student_submit: "Student: after submitting", student_grant: "Student: after first grant" };
